import { AxiosResponse } from "axios";
import { normalize, schema } from 'normalizr';
import { createAsyncThunk } from "@reduxjs/toolkit";
import modsFactoryApi from '../../api/modsFactoryApi';
import modsfactoryUrls from "../../configs/mods_factory/modsfactoryUrls";
import { SkinInterface } from "../../store/mods_factory/skinsSlice";

const PREFIX = 'mods_factory';

const processStrategy = (value: any) => {
  return {
    ...value,
    url: modsfactoryUrls.skinPath(value.id),
    thumbnail_url: modsfactoryUrls.remoteUrl(value.thumbnail_url),
    saven_image_url: modsfactoryUrls.remoteUrl(value.saven_image_url)
  };
}

const skinsEntity = new schema.Entity(
  'skins',
  {},
  {
    processStrategy
  }
);

const skinEntity = new schema.Entity(
  'skin',
  {},
  {
    processStrategy
  }
);

const normalizeInstance = (response: AxiosResponse) => {
  const normalized = normalize<any, { skin: SkinInterface }>(response.data.skin, skinEntity);
  return normalized.entities;
}

export const fetchSkins = createAsyncThunk(
  `${PREFIX}_skins/fetchSkins`,
  async (params: object = {}) => {
    const response    = await modsFactoryApi.get(`/onesky/skins`, { params })
    const normalized  = normalize<any, { skins: { [key: string]: SkinInterface } }>(response.data.skins, [skinsEntity]);

    return {
      skins: normalized.entities?.skins || {},
      ids: normalized.result,
      count: response.data.meta?.total_count
    };
  }
);

export const fetchSkin = createAsyncThunk(
  `${PREFIX}_skins/fetchSkin`,
  async (id: number | string) => {
    const response = await modsFactoryApi.get(`/onesky/skins/${id}`);
    return normalizeInstance(response);
  }
);

export const createSkin = createAsyncThunk(
  `${PREFIX}_skins/createSkin`,
  async (data: object, { rejectWithValue }) => {
    try {
      const response = await modsFactoryApi.post(`/onesky/skins`, data);
      return normalizeInstance(response);
    } catch (error: any) {
      return rejectWithValue(error?.response?.data || error);
    }
  }
);

export const updateSkin = createAsyncThunk(
  `${PREFIX}_skins/updateSkin`,
  async ({ id, data }: { id: number, data: object }, { rejectWithValue }) => {
    try {
      const response = await modsFactoryApi.patch(`/onesky/skins/${id}`, data);
      return normalizeInstance(response);
    } catch (error: any) {
      return rejectWithValue(error.response.data || error)
    }
  }
);

export const destroySkin = createAsyncThunk(
  `${PREFIX}_skins/destroySkin`,
  async (id: number) => {
    const response = await modsFactoryApi.delete(`/onesky/skins/${id}`);
    return response.data;
  }
);
